import { State } from 'app/redux';

export const getTrackingTypes = (state: State) => state.tracking.trackingTypes;
